import { Injectable } from '@angular/core';
import { SessionService } from './session.service';


@Injectable({
  providedIn: 'root'
})
export class RoleGuardService  {

  constructor(private sessionService: SessionService) { }

  canActivate(): boolean {
    const user = this.sessionService.getUser();
    if (user.golfTechType.toString() === '5' || user.golfTechType.toString() === '1') {
      return true;
    }
    return false;
  }
}
